// import Swiper JS
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    // Featured Authors Swiper
    const swiper = new Swiper('.featured-authors-slider', {
        modules: [Navigation],
        speed: 900,
        direction: 'horizontal',
        observer: true,
        observeParents: true,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1024: { slidesPerView: 3 }, 
            768: { slidesPerView: 2 }, 
            480: { slidesPerView: 1 }
        }
    });

    // Related Posts Swiper
    const swiperNew = new Swiper('.related-posts-slider', {
        modules: [Navigation],
        speed: 900,
        direction: 'horizontal',
        observer: true,
        observeParents: true,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1024: { slidesPerView: 3 }, 
            768: { slidesPerView: 2 }, 
            480: { slidesPerView: 1 }
        }
    });
});


document.addEventListener('DOMContentLoaded', function () {
    const seeMoreBtn = document.querySelector('.see-more-btn');
    const bioFull = document.querySelector('.bio-full');
    const bioPreview = document.querySelector('.bio-preview');

    if (seeMoreBtn && bioFull) {
        seeMoreBtn.addEventListener('click', function () {
            bioFull.classList.toggle('max-h-screen'); 
            bioPreview.classList.toggle('h-0'); 
            bioPreview.classList.toggle('invisible'); 

            if (bioFull.classList.contains('max-h-screen')) {
                seeMoreBtn.textContent = 'See Less';
            } else {
                seeMoreBtn.textContent = 'See More';
            }
        });
    }
});
